// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__3dGN4","upload":"Small_upload__EWil2","imageWrap":"Small_imageWrap__NvsQs","removeBtn":"Small_removeBtn__3y1jq"};